export default __webpack_public_path__ + "static/media/noa-1.bfc3f6c0.jpg";